<template>
	<ConditionalRenderingFieldsForm
		v-if="canRenderForm"
		:action="action"
		:service="service"
		:credentialsConfiguration="mappedCredentialsConfiguration"
		:fields="fields"
		:params="requiredParams"
		v-bind="$attrs"
		v-on="$listeners"
	/>
</template>

<script>
import { mapActionsShorthand, mapGettersShorthand } from '@/store/utils/mappers';
import { getAction } from '@/store/modules/actions/getters';
import ConditionalRenderingFieldsForm from './ConditionalRenderingFieldsForm.vue';
import { getActionsOfApp } from '@/store/modules/apps/actions';
import { getService, getServiceAllActions } from '@/store/modules/apps/getters';
import AppActionService from '@/utils/AppActionService';
export default {
	name: 'ConditionalRenderingFieldsFormDataProvider',
	props: {
		contextActionId: { type: Number },
		contextServiceId: { type: Number },
		credentialsConfiguration: { type: Object },
		fields: { type: Array },
	},
	components: { ConditionalRenderingFieldsForm },
	computed: {
		...mapGettersShorthand({ getAction, getService, getServiceAllActions }),
		service() {
			return this.getService(this.contextServiceId);
		},
		action() {
			return this.getAction(this.contextActionId);
		},
		serviceVersion() {
			return this.service.version;
		},
		mappedCredentialsConfiguration() {
			const { id, type } = this.credentialsConfiguration;
			return { credentials: id, credentials_type: type };
		},
		fieldsToParams() {
			// the params of contextual action, related to the received fields
			return this.fields.map((paramKey) => this.action.params.find((param) => param.key === paramKey));
		},
		allFieldsAvailable() {
			return this.fields.every((paramKey) => this.action.params.findIndex((param) => param.key === paramKey) !== -1);
		},
		requiredParams() {
			return this.fieldsToParams
				.map((param) => AppActionService.getRequiredActionParamsFromParamDependsOn(param, this.action, this.getActionByKey))
				.flat()
				.reverse();
		},
		allActionsOfSelectedApp() {
			return this.getServiceAllActions(this.service.id).actions;
		},
		actionsOfAppRetrieved() {
			return this.allActionsOfSelectedApp?.length > 0;
		},
		allDataOfFormIsReady() {
			return !!this.action && this.actionsOfAppRetrieved;
		},
		canRenderForm() {
			return this.allDataOfFormIsReady && this.allFieldsAvailable;
		},
	},
	methods: {
		...mapActionsShorthand({ getActionsOfApp }),
		getActionByKey(actionKey) {
			return this.allActionsOfSelectedApp.find((action) => action.key === actionKey);
		},
		emitAllFieldsAvailableState() {
			// handling special edge case - we have conditional rendering fields instead of service workspace support,
			// letting the parent know if current form is necessary
			this.$emit('all-fields-available', this.allFieldsAvailable);
		},
	},
	mounted() {
		if (this.contextActionId) {
			this.getActionsOfApp({ id: this.contextServiceId, version: this.serviceVersion });
		}
	},
	watch: {
		allDataOfFormIsReady: {
			handler(newV) {
				newV && this.emitAllFieldsAvailableState();
			},
			immediate: true,
		},
	},
};
</script>

<style scoped lang="scss"></style>
